module.exports = __webpack_public_path__ + "static/media/comviva.c305237b.png";